import React from 'react';
import { IconContext } from 'react-icons';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdClose } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';

import { useAppDispatch, useAppSelector } from '../redux/store';
import { clearEditingServiceId } from '../redux/slices/ServiceEditorSlice';
import { toggleShowMenu } from '../redux/slices/menuSlice';
import { getUser } from '../api/auth';
import styles from './styles/header.module.scss';

interface HeaderProps {
  headerText: string;
  showBurger: boolean;
}

export const Header: React.FC<HeaderProps> = ({ headerText, showBurger }) => {
  const navigate = useNavigate();

  const hasCookies = useAppSelector((state) => state.auth.hasCookies);
  const dispatch = useAppDispatch();

  // server state
  const { data: user, isLoading: isAvatarLoading } = useQuery('user', getUser, {
    enabled: hasCookies,
  });

  // console.log(user);

  const handleClickClose = () => {
    dispatch(clearEditingServiceId());
    navigate('/');
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        {showBurger && (
          <div className={styles.burger}>
            <IconContext.Provider
              value={{
                style: { width: '23px', height: '23px' },
              }}
            >
              <GiHamburgerMenu onClick={() => dispatch(toggleShowMenu())} />
            </IconContext.Provider>
          </div>
        )}

        <div
          className={styles.logo}
          style={{
            fontFamily:
              headerText === 'Maven Note'
                ? "'Mulish', sans-serif"
                : "'Roboto', sans-serif",
          }}
        >
          {headerText}
        </div>

        <div className={styles.right}>
          {showBurger ? (
            !isAvatarLoading &&
            hasCookies && (
              <img
                src={user?.avatarUrl}
                alt="avatar"
                className={styles.avatar}
              />
            )
          ) : (
            <IconContext.Provider
              value={{
                style: { width: '34px', height: '34px' },
              }}
            >
              <MdClose onClick={handleClickClose} />
            </IconContext.Provider>
          )}
        </div>
      </div>
    </div>
  );
};
